/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-view': {
    width: 10,
    height: 8,
    viewBox: '0 0 10 8',
    data: '<defs><path pid="0" d="M5 6.315c-1.252 0-2.26-1.04-2.26-2.315S3.747 1.685 5 1.685c1.252 0 2.26 1.04 2.26 2.315S6.253 6.315 5 6.315zm0-.968c.71 0 1.293-.6 1.293-1.347S5.71 2.653 5 2.653c-.71 0-1.293.6-1.293 1.347S4.29 5.347 5 5.347zm4.894-1.562L10 4l-.106.215C8.895 6.233 7.05 7.513 5 7.513c-2.05 0-3.895-1.28-4.894-3.298L0 4l.106-.215C1.105 1.767 2.95.487 5 .487c2.05 0 3.895 1.28 4.894 3.298zM5 1.455c-1.59 0-3.053.968-3.915 2.545C1.947 5.577 3.41 6.545 5 6.545c1.59 0 3.053-.968 3.915-2.545C8.053 2.423 6.59 1.455 5 1.455z" id="svgicon-icon-view-a"/></defs><use _fill="#376F99" xlink:href="#svgicon-icon-view-a" fill-rule="evenodd"/>'
  }
})
